<template>
    
        <div class="module_container">
            <!-- 1 RECOGIDA -->
            <recogida :datos="FORMULARIO.recogida" :facturacion="FORMULARIO.facturacion" :tipoDNI="getTipoDNI"></recogida>

            <!-- 2 ENTREGA -->
            <br /><br />
            <br /><br />
            <h1 style="font-family: Heebo; font-size: 26px; color: black; font-weight: bold ">2. Datos de entrega</h1>
            <br /><br />
            <br /><br />
            
                  <div  data-is-visible="true">
                      <h3 style="font-family: Heebo; font-size: 22px; color: black; font-weight: normal ">
                          ¿Quieres usar los mismos datos de entrega y recogida?
                      </h3>
                      <br /><br />
                      <br /><br />
                      
        <div class="controls mb-1">
         <input id="rb_seguro_si"
                type="radio"
                name="radio-group-seguro"
                v-model="FORMULARIO.igualEntrega"
                :value="true" />
         <label class="text--s" for="rb_seguro_si" style="font-family: Heebo; font-weight: normal">Sí</label>
     </div>
     <div class="controls">
         <input id="rb_seguro_no"
                type="radio"
                name="radio-group-seguro"
                v-model="FORMULARIO.igualEntrega"
                :value="false" />
         <label class="text--s" for="rb_seguro_no" style="font-family: Heebo; font-weight: normal">No</label>
     </div>
    
                  </div>

       
            
         <entrega v-if="!FORMULARIO.igualEntrega"
             :datos="FORMULARIO.entrega"
             :tipoDNI="getTipoDNI"></entrega>
    
            <!-- 3 HORARIO -->
            
    <horario v-if="!FORMULARIO.recogida.enTienda" :datos="FORMULARIO.horario"></horario>
                
            <!-- 4 DISPOSITIVO -->
            <dispositivo :dispositivo="FORMULARIO.dispositivo" :cp="FORMULARIO.recogida.zipcode" :especiales="FORMULARIO.especiales" :tipoDNI="getTipoDNI"></dispositivo>
        </div>
    
</template>

<script>
    import recogida from "@/components/formulario/recogida";
    import entrega from "@/components/formulario/entrega";
    import horario from "@/components/formulario/horario";
    import dispositivo from "@/components/formulario/dispositivo";

    export default {
        components: {
            recogida,
            entrega,
            horario,
            dispositivo,
        },
        data: () => ({
            FORMULARIO: {},
        }),
        computed: {
            esEmpresa() {
                return this.$bus.formulario.company;
            },
            esCAC() {
                return this.$bus.formulario.empresaSinRegistrar;
            },
            getTipoDNI() {
                return this.esEmpresa ? "" : this.esCAC ? "CIF/NIF/DNI" : "DNI";
            },
        },
        created() {
            this.FORMULARIO = this.$bus.formulario;

            //Empresas
            if (this.FORMULARIO.company) {
                this.recogidacp = this.FORMULARIO.recogida.zipcode;
                this.recogidapoblacion = this.FORMULARIO.recogida.town;
                this.entregacp = this.FORMULARIO.entrega.zipcode;
                this.entregapoblacion = this.FORMULARIO.entrega.town;
                this.cargandoDatos = false;
            }
            //datos de particular logeado
            if (this.$bus.login && this.$bus.datosUsuario != undefined) {
                this.FORMULARIO.recogida.name = this.$bus.datosUsuario.cliente.nombre;
                this.FORMULARIO.recogida.telephone =
                    this.$bus.datosUsuario.cliente.telefono;
                this.FORMULARIO.recogida.mail = this.$bus.datosUsuario.cliente.mail;
                this.FORMULARIO.recogida.cif = this.$bus.datosUsuario.cliente.dni;
                this.FORMULARIO.recogida.zipcode = this.$bus.datosUsuario.direccion.cp;
                this.FORMULARIO.recogida.address =
                    this.$bus.datosUsuario.direccion.direccion;
                this.FORMULARIO.recogida.town =
                    this.$bus.datosUsuario.direccion.poblacion;
                this.FORMULARIO.recogida.province =
                    this.$bus.datosUsuario.direccion.provincia;
            }
        },
    };
</script>

<style lang="scss">
    @font-face {
        font-family: 'Heebo';
        src: url('/fonts/heebo-regular.woff');
        font-weight: 400;
    }

    @font-face {
        font-family: 'Heebo';
        src: url('/fonts/heebo-bold.woff');
        font-weight: bold;
    }
    ::placeholder {
        font-family: Heebo;
        color: #606060;
        font-weight: normal
    }

    .module:not(footer) {
        margin-bottom: calc(var(--grid_columns_size) * 1.2 - 0.1px);
    }

    .input--s {
        margin-right: 4.8rem;
    }

    .input--xs {
        margin-right: 6.5rem;
    }

    .ml-1 {
        margin-left: 1rem;
    }

    .mb-1 {
        margin-bottom: 1rem !important;
    }

    .mb-2 {
        margin-bottom: 2rem !important;
    }

    .mb-3 {
        margin-bottom: 3rem !important;
    }

    .mb-8 {
        margin-bottom: 8rem !important;
    }

    .p-error {
        color: #ea2158;
    }

    .input-error .button-arrow {
        background-color: #ea2158;
    }

    .input-error select {
        border-color: #ea2158 !important;
        color: #ea2158;
    }
/*
    input[type="radio"]:checked + label:before,
    input[type="radio"]:not(:checked) + label:before {
        width: 2.2rem;
        height: 2.2rem;
    }*/

    .input-error textarea {
        border-color: #ea2158 !important;
        color: #ea2158;
    }

    p.bold {
        font-weight: bold;
    }

    p.bolder {
        font-weight: bolder;
    }

    #rb_seguro_si {
        border: 2px solid white;
        box-shadow: 0 0 0 0.5px black;
        appearance: none;
        border-radius: 50%;
        width: 16px;
        height: 16px;
        background-color: #fff;
        transition: all ease-in 0.2s;
    }

    #rb_seguro_si {
        background-color: #9be51a;
    }

</style>




